import { render, staticRenderFns } from "./supplierProfile.vue?vue&type=template&id=98a696ac&"
import script from "./supplierProfile.vue?vue&type=script&lang=js&"
export * from "./supplierProfile.vue?vue&type=script&lang=js&"
import style0 from "./supplierProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports